import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Skeleton } from "@/shared/ui";

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="space-y-4 w-64">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Suspense fallback={<PageFallback />}>
        <Outlet />
      </Suspense>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          className: "font-sans",
        }}
      />
    </>
  );
}
